import { t } from 'typegate';
export const ApplicationModes = {
    digital: 'digital',
    paper: 'paper',
};
export const applicationMode = t.union(t.literal('digital'), t.literal('paper'));
export const ApplicationModesDefault = [ApplicationModes.digital, ApplicationModes.paper];
